import * as React from "react";
import { StandardProps, PropTypes as MuiPropTypes } from "@material-ui/core";
import { ButtonBaseProps } from "@material-ui/core/ButtonBase";
import MuiIconButton, { IconButtonProps as MuiIconButtonProps, IconButtonClassKey as MuiIconButtonClassKey } from "@material-ui/core/IconButton";
import { withStyles, createStyles, Theme } from './styles';
import { PropTypes } from "../index";
import { fade } from '@material-ui/core/styles/colorManipulator';



export interface IconButtonProps extends StandardProps<ButtonBaseProps, IconButtonClassKey> {
    color?: PropTypes.Color;
    disabled?: boolean;
    disableRipple?: boolean;
}

export type IconButtonClassKey = // MuiIconButtonClassKey

    |'root'

    | 'colorSuccess'
    | 'colorInfo'
    | 'colorWarning'
    | 'colorDanger'
    ;



const styles = ({ palette }: Theme) => {

    return createStyles({
        root: {},
        disabled: {},
        colorSuccess: {
            color: palette.success.main,
            '&:hover': {
                backgroundColor: fade(palette.success.main, palette.action.hoverOpacity),
                '@media (hover: none)': {
                    backgroundColor: 'transparent',
                },
            },
        },
        colorWarning: {
            color: palette.warning.main,
            '&:hover': {
                backgroundColor: fade(palette.warning.main, palette.action.hoverOpacity),
                '@media (hover: none)': {
                    backgroundColor: 'transparent',
                },
            },
        },
        colorInfo: {
            color: palette.info.main,
            '&:hover': {
                backgroundColor: fade(palette.info.main, palette.action.hoverOpacity),
                '@media (hover: none)': {
                    backgroundColor: 'transparent',
                },
            },
        },
        colorDanger: {
            color: palette.danger.main,
            '&:hover': {
                backgroundColor: fade(palette.danger.main, palette.action.hoverOpacity),
                '@media (hover: none)': {
                    backgroundColor: 'transparent',
                },
            },
        },
    })
};


class IconButton extends React.PureComponent<IconButtonProps> {
    render() {
        const { classes, color, ...props } = this.props;
        let buttonColor: MuiPropTypes.Color = 'primary';
        let buttonClasses = {};
        switch (color) {

            case 'success':
                buttonClasses = {
                    colorPrimary: classes.colorSuccess,
                }
                break;

            case 'danger':
                buttonClasses = {
                    colorPrimary: classes.colorDanger,
                }
                break;

            case 'warning':
                buttonClasses = {
                    colorPrimary: classes.colorWarning,
                }
                break;

            case 'info':
                buttonClasses = {
                    colorPrimary: classes.colorInfo,
                }
                break;

            default:
                buttonColor = color;
        }

        buttonClasses = { ...buttonClasses, root: classes.root }


        const buttonProps: MuiIconButtonProps = {
            ...(props as MuiIconButtonProps),
            color: buttonColor,
            classes: buttonClasses
        };

        return <MuiIconButton {...buttonProps}>
            {this.props.children}
        </MuiIconButton>;
    }
}

//export default IconButton;
export default withStyles(styles)(IconButton);
